import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';

import video3 from '../../assets/3.mp4';
import video2 from '../../assets/2.mp4';
import video1 from '../../assets/1.mp4';
import aboutImg from '../../assets/Baby/about.jpg';

import GynaeSection from '../GynaeSection';
import DoctorSection from '../Section/DrSection';
import Advantages from '../AdvantageSection/AdvantageSection';

const Home = () => {
  const videos = [video1, video2, video3];
  const randomVideo = videos[Math.floor(Math.random() * videos.length)];

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        'https://amaanativf.com/api/appointment_submit.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setIsSubmitted(true);
        setFormData({
          name: '',
          email: '',
          phone: '',
          date: '',
          message: '',
        });
      } else {
        alert(data.message || 'Submission failed');
      }
    } catch (error) {
      alert('Server error. Please try again later.');
    }

    setLoading(false);
  };

  return (
    <div className="home">

      {/* ✅ SEO START */}
      <Helmet>
        <title>Best IVF Centre in Ambala | Amaanat IVF Clinic</title>

        <meta
          name="description"
          content="Amaanat IVF is a leading fertility and IVF centre in Ambala offering IVF, ICSI, IUI, and advanced reproductive treatments with high success rates."
        />

        <meta
          name="keywords"
          content="IVF centre in Ambala, fertility clinic Ambala, ICSI treatment, IUI, best IVF doctor, test tube baby centre"
        />

        <link rel="canonical" href="https://amaanativf.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="Amaanat IVF - Best IVF Centre in Ambala" />
        <meta property="og:description" content="Start your journey to parenthood with advanced IVF treatments at Amaanat IVF." />
        <meta property="og:url" content="https://amaanativf.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://amaanativf.com/logo.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        {/* ✅ Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            "name": "Amaanat IVF",
            "url": "https://amaanativf.com",
            "logo": "https://amaanativf.com/logo.png",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Ambala",
              "addressCountry": "India"
            },
            "medicalSpecialty": "Fertility"
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* Hero Video Section */}
      <section className="hero-video">
        <video autoPlay muted loop playsInline preload="none" className="hero-video-bg">
          <source src={randomVideo} type="video/mp4" />
        </video>

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h1 className="hero-title">
            Your Journey to Parenthood Starts Here
          </h1>

          <p className="hero-subtitle">
            Advanced IVF treatments with higher success rates
          </p>

          <div className="hero-buttons">
            <a href="#appointment" className="btn-appointment">
              Book Appointment
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">

          <h2 className="section-title">Our IVF & Fertility Services</h2>

          <div className="services-grid">

            <div className="service-card">
              <div className="service-icon">💉</div>
              <h3>Intrauterine Insemination (IUI)</h3>
              <p>Supportive treatment to enhance natural conception chances</p>
            </div>

            <div className="service-card">
              <div className="service-icon">🔬</div>
              <h3>In-Vitro Fertilization (IVF)</h3>
              <p>Advanced IVF procedures with high success rates</p>
            </div>

            <div className="service-card">
              <div className="service-icon">🧬</div>
              <h3>ICSI Treatment</h3>
              <p>Specialized treatment for male infertility issues</p>
            </div>

            <div className="service-card">
              <div className="service-icon">🧫</div>
              <h3>Oocyte Pickup</h3>
              <p>Safe and precise egg retrieval procedure</p>
            </div>

            <div className="service-card">
              <div className="service-icon">🧪</div>
              <h3>Embryo Transfer</h3>
              <p>Careful placement of embryos for successful implantation</p>
            </div>

            <div className="service-card">
              <div className="service-icon">👩‍🍼</div>
              <h3>Egg Donor Program</h3>
              <p>Trusted donor programs for assisted reproduction</p>
            </div>

            <div className="service-card">
              <div className="service-icon">🤰</div>
              <h3>Obstetrics & Gynae</h3>
              <p>Complete care for pregnancy and women's health</p>
            </div>

            <div className="service-card">
              <div className="service-icon">👶</div>
              <h3>Pediatrics</h3>
              <p>Comprehensive healthcare for newborns and children</p>
            </div>

          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container about-wrapper">

          <div className="about-image">
            <img
              src={aboutImg}
              loading="lazy"
              alt="Amaanat IVF Clinic in Ambala - Fertility Treatment Center"
            />
          </div>

          <div className="about-content">
            <span className="gynae-tag">About Amaanat IVF</span>

            <h2>
              A private <span>fertility and IVF clinic</span><br />
              for women and couples
            </h2>

            <p>
              Our leading fertility clinic provides world-class fertility
              treatments with expert care and advanced technology.
            </p>

            <Link to="/about" title="About Amaanat IVF Clinic" className='about-btn'>
              Find Out More
            </Link>
          </div>
        </div>
      </section>

      <GynaeSection />

      {/* Appointment */}
      <section id="appointment" className="appointment-section">
        <div className="container">
          <div className="appointment-content">

            <div className="appointment-text">
              <h2 className='heading-1'>Book IVF Consultation in Ambala</h2>
              <p>Book your appointment today. No obligation, just answers.</p>
            </div>

            {isSubmitted ? (
              <div className="appointment-success">
                <h3>✅ Appointment Booked Successfully</h3>
                <p>Our team will contact you shortly.</p>
              </div>
            ) : (
              <form className="appointment-form" onSubmit={handleSubmit}>

                <div className="form-group">
                  <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
                </div>

                <div className="form-row">
                  <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleInputChange} required />
                  <input type="tel" name="phone" placeholder="Phone" value={formData.phone} onChange={handleInputChange} required />
                </div>

                <input type="date" name="date" value={formData.date} onChange={handleInputChange} required />

                <button type="submit" className="form-btnn" disabled={loading}>
                  {loading ? 'Submitting...' : 'Schedule Appointment'}
                </button>

              </form>
            )}
          </div>
        </div>
      </section>

      <DoctorSection />

      {/* Advantages */}
      {/* <section className="advantages-section">
        <div className="container">

          <h2 className="section-title">
            Why Choose Amaanat IVF Centre
          </h2>

          <div className="advantages-grid">
            <div className="advantage-item">
              <h3>Advanced Medical Treatments</h3>
              <p>Latest IVF technologies with high success rates.</p>
            </div>

            <div className="advantage-item">
              <h3>World-Class Facilities</h3>
              <p>Modern infrastructure for best fertility outcomes.</p>
            </div>

            <div className="advantage-item">
              <h3>Experienced Specialists</h3>
              <p>Expert IVF doctors and embryologists.</p>
            </div>

            <div className="advantage-item">
              <h3>Personalized Care</h3>
              <p>Customized fertility plans for every patient.</p>
            </div>
          </div>

        </div>
      </section> */}
            <Advantages />
    </div>
  );
};

export default Home;